import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Container,
  makeStyles,
  Snackbar,
  IconButton,
  CircularProgress,
  Tooltip,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import {
  Edit,
  Delete,
  ArrowBack,
  PlayArrow,
  Stop,
  RemoveRedEye,
  ListAlt,
  Info,
  Feed,
  MapsHomeWork,
  Receipt,
} from "@mui/icons-material";

import {
  PopUpWindow,
  AddActionForm,
  ChecklistForm,
  AddTicketForm,
  ViewProperty,
  AddReservationForm,
} from "../../components";
import io from "socket.io-client";

import axios from "axios";

const socket = io("https://server.rhodesholidaysvillas.com/");

const ViewActionsForm = (props) => {
  const [actions, setActions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [timerValue, setTimerValue] = useState("");

  const [selectedAction, setSelectedAction] = useState("");
  const [popUpWindowIsOpen, setPopUpWindowIsOpen] = useState(false);
  const [checkListOpen, setCheckListOpen] = useState(false);
  const [moreInfoOpen, setMoreInfoOpen] = useState(false);
  const [addTicketOpen, setAddTicketOpen] = useState(false);
  const [propertyInfoOpen, setPropertyInfoOpen] = useState(false);
  
  // Add new states for reservation view
  const [viewReservation, setViewReservation] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [selectingReservation, setSelectingReservation] = useState(false);
  const [actionReservations, setActionReservations] = useState([]);
  const [loadingReservations, setLoadingReservations] = useState(false);
  
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchActions();
  }, []);

  useEffect(() => {
    let interval = null;

    if (selectedAction.start_date && !selectedAction.end_date) {
      // Update the timer value every second
      interval = setInterval(() => {
        const now = new Date();
        const start = new Date(selectedAction.start_date);
        const duration = new Date(now - start);
        const durationString = new Date(duration).toISOString().substr(11, 8);
        setTimerValue(durationString);
      }, 1000); // Update every second
    } else {
      setTimerValue(initializeTimer());
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [selectedAction.start_date, selectedAction.end_date]);

  useEffect(() => {
    const handleActionUpdate = (data) => {
      if (actions.find((action) => action._id === data._id)) {
        setActions(
          actions.map((action) => {
            if (action._id === data._id) {
              return data;
            }
            return action;
          })
        );
      }
    };

    socket.on("actionUpdated", handleActionUpdate);

    return () => {
      socket.off("actionUpdated");
    };
  }, [actions]);
  
  // Add effect to fetch reservations when an action is selected
  useEffect(() => {
    if (selectedAction && selectedAction._id) {
      fetchActionReservations(selectedAction._id);
    }
  }, [selectedAction]);

  const fetchActionReservations = async (actionId) => {
    try {
      setLoadingReservations(true);
      const response = await axios.get(
        `https://server.rhodesholidaysvillas.com/action/getActionReservations/${actionId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setActionReservations(response.data.reservations || []);
      setLoadingReservations(false);
    } catch (err) {
      console.error("Failed to fetch reservations:", err);
      setLoadingReservations(false);
    }
  };
  
  const handleViewReservation = (reservation) => {
    setSelectedReservation(reservation);
    setViewReservation(true);
    setSelectingReservation(false);
  };

  const initializeTimer = () => {
    if (selectedAction.start_date && selectedAction.end_date) {
      const start = new Date(selectedAction.start_date);
      const end = new Date(selectedAction.end_date);
      const duration = new Date(end - start);
      return new Date(duration).toISOString().substr(11, 8);
    }
    return "00:00:00";
  };

  const fetchActions = async () => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const nextDay = new Date();
      nextDay.setHours(0, 0, 0, 0);
      nextDay.setDate(nextDay.getDate() + 7);
      const res = await axios.get(
        `https://server.rhodesholidaysvillas.com/action/getMyUpcomingActions?startDate=${today.toISOString()}&endDate=${nextDay.toISOString()}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setActions(res.data.actions);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const resetAllViews = () => {
    setMoreInfoOpen(false);
    setCheckListOpen(false);
    setAddTicketOpen(false);
    setPropertyInfoOpen(false);
    setViewReservation(false);
    setSelectingReservation(false);
  };

  return (
    <div className="upcoming-actions-table">
      {popUpWindowIsOpen && !isLoading && (
        <PopUpWindow
          onClose={() => {
            resetAllViews();
            setPopUpWindowIsOpen(false);
          }}
          unfocusClose={true}
        >
          <div
            className="add-ticket-form"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              padding: "20px",
            }}
          >
            {!moreInfoOpen &&
              !checkListOpen &&
              !addTicketOpen &&
              !propertyInfoOpen &&
              !viewReservation &&
              !selectingReservation && (
                <div className="timer">
                  <div className="start-time">
                    <Typography variant="h6">
                      Start:{" "}
                      {selectedAction.start_date
                        ? new Date(
                            selectedAction.start_date
                          ).toLocaleTimeString()
                        : "Δεν έχει ξεκινήσει"}
                    </Typography>
                  </div>
                  <div className="end-time">
                    <Typography variant="h6">
                      End:{" "}
                      {selectedAction.end_date
                        ? new Date(selectedAction.end_date).toLocaleTimeString()
                        : "Δεν έχει λήξει"}
                    </Typography>
                  </div>

                  <div className="notes">
                    <Typography variant="h6">
                      Notes: {selectedAction.notes || "-"}
                    </Typography>
                  </div>
                  
                  {/* Display connected reservations if they exist */}
                  {actionReservations && actionReservations.length > 0 && (
                    <div className="action-reservations">
                      <Typography variant="h6">Connected Reservations:</Typography>
                      <ul className="reservation-list">
                        {actionReservations.map(res => (
                          <li key={res._id}>
                            {res.reservationId} - {res.firstName} {res.lastName}
                            <span className="reservation-dates">
                              ({new Date(res.checkIn).toLocaleDateString()} to {new Date(res.checkOut).toLocaleDateString()})
                            </span>
                          </li>
                        ))}
                      </ul>
                      
                      {/* Add View Reservation button */}
                      <div className="view-reservation-button" style={{ marginTop: "10px" }}>
                        <button
                          className="action-button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            padding: "6px 12px",
                            backgroundColor: "var(--primary-color)",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (actionReservations.length === 1) {
                              handleViewReservation(actionReservations[0]);
                            } else {
                              setSelectingReservation(true);
                            }
                          }}
                        >
                          <Receipt fontSize="small" />
                          <span>View Reservation{actionReservations.length > 1 ? 's' : ''}</span>
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="timer-total">
                    <Typography
                      variant="h3"
                      style={{
                        paddingTop: "20px",
                        display: "flex",
                        gap: "10px",
                        alignSelf: "center",
                        justifySelf: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "var(--primary-color)",
                      }}
                    >
                      {timerValue}
                    </Typography>
                  </div>

                  <div
                    className="timer-buttons"
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignSelf: "center",
                      justifySelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {((!selectedAction.start_date &&
                      (!selectedAction.end_date ||
                        selectedAction.end_date === "")) ||
                      selectedAction.end_date) && (
                      <Button
                        style={{
                          backgroundColor: "var(--primary-color)",
                          color: "var(--tertiary-color)",
                          borderRadius: "50%",
                        }}
                        onClick={() => {
                          if (!selectedAction.start_date) {
                            axios
                              .put(
                                `https://server.rhodesholidaysvillas.com/action/updateAction/${selectedAction._id}`,
                                {
                                  start_date: new Date(),
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer ${user.token}`,
                                  },
                                }
                              )
                              .then((res) => {
                                setSelectedAction({
                                  ...selectedAction,
                                  start_date: new Date(),
                                });
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          } else {
                            console.log("stop");
                            axios
                              .put(
                                `https://server.rhodesholidaysvillas.com/action/updateAction/${selectedAction._id}`,
                                {
                                  end_date: "-",
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer ${user.token}`,
                                  },
                                }
                              )
                              .then((res) => {
                                setSelectedAction({
                                  ...selectedAction,
                                  end_date: "",
                                });
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }
                        }}
                      >
                        <PlayArrow fontSize="large" />
                      </Button>
                    )}

                    {selectedAction.start_date && !selectedAction.end_date && (
                      <Button
                        style={{
                          backgroundColor: "var(--primary-color)",
                          color: "var(--tertiary-color)",
                          borderRadius: "50%",
                        }}
                        onClick={() => {
                          axios
                            .put(
                              `https://server.rhodesholidaysvillas.com/action/updateAction/${selectedAction._id}`,
                              {
                                end_date: new Date(),
                              },
                              {
                                headers: {
                                  Authorization: `Bearer ${user.token}`,
                                },
                              }
                            )
                            .then((res) => {
                              setSelectedAction({
                                ...selectedAction,
                                end_date: new Date(),
                              });
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }}
                      >
                        <Stop fontSize="large" />
                      </Button>
                    )}
                  </div>
                </div>
              )}
              
            {/* Reservation selection interface */}
            {selectingReservation && (
              <div className="select-reservation-view">
                <Typography variant="h6" gutterBottom>
                  Select a reservation to view:
                </Typography>
                <List>
                  {actionReservations.map(res => (
                    <ListItem 
                      button
                      key={res._id}
                      onClick={() => handleViewReservation(res)}
                    >
                      <ListItemText 
                        primary={`${res.reservationId} - ${res.firstName} ${res.lastName}`} 
                        secondary={`${new Date(res.checkIn).toLocaleDateString()} to ${new Date(res.checkOut).toLocaleDateString()}`} 
                      />
                    </ListItem>
                  ))}
                </List>
                
                <div className="back-button">
                  <button
                    className="add-ticket-button__button"
                    style={{
                      backgroundColor: "var(--secondary-color)",
                      color: "var(--primary-text-color)",
                      fontSize: "15px",
                      fontWeight: "600",
                      width: "100%",
                    }}
                    onClick={() => setSelectingReservation(false)}
                  >
                    <ArrowBack />
                    <span>Back</span>
                  </button>
                </div>
              </div>
            )}
            
            {/* View Reservation */}
            {viewReservation && selectedReservation && (
              <div className="view-reservation">
                <AddReservationForm
                  view={true}
                  reservationId={selectedReservation._id}
                  property={selectedAction.property.name}

                  
                  nights={selectedReservation.nights}
                  adults={selectedReservation.adults}
                  kids={selectedReservation.kids}
                  checkIn={selectedReservation.checkIn}
                  checkOut={selectedReservation.checkOut}
                  staffNotes={selectedReservation.staffNotes || ""}
                  firstName={selectedReservation.firstName}
                  lastName={selectedReservation.lastName}
                  email={selectedReservation.email}
                  phone={selectedReservation.phone}
                  cribs={selectedReservation.cribs}
                  highChairs={selectedReservation.highChairs}
                  idPassport={selectedReservation.idPassport}
                  guestTotal={selectedReservation.guestTotal}
                  channel={selectedReservation.channel}
                  channelAmount={selectedReservation.channelAmount}
                  customerNotes={selectedReservation.customerNotes || ""}
                  arrivalTime={selectedReservation.arrivalTime}
                  arrivalLocation={selectedReservation.arrivalLocation || ""}
                  arrivalFlight={selectedReservation.arrivalFlight || ""}
                  departureTime={selectedReservation.departureTime}
                  departureLocation={selectedReservation.departureLocation || ""}
                  departureFlight={selectedReservation.departureFlight || ""}
                  reservation_id={selectedReservation.reservationId}
                />
                
                <div className="back-button">
                  <button
                    className="add-ticket-button__button"
                    style={{
                      backgroundColor: "var(--secondary-color)",
                      color: "var(--primary-text-color)",
                      fontSize: "15px",
                      fontWeight: "600",
                      width: "100%",
                      marginTop: "20px"
                    }}
                    onClick={() => setViewReservation(false)}
                  >
                    <ArrowBack />
                    <span>Back</span>
                  </button>
                </div>
              </div>
            )}
              
            {!moreInfoOpen &&
              !checkListOpen &&
              !addTicketOpen &&
              !propertyInfoOpen &&
              !viewReservation &&
              !selectingReservation && (
                <div
                  className="add-ticket-button"
                  style={{
                    display: JSON.parse(localStorage.getItem("user"))
                      .permissions.canCreateTicket
                      ? "flex"
                      : "none",
                  }}
                >
                  <button
                    className="add-ticket-button__button"
                    style={{
                      backgroundColor: props.color || "var(--primary-color)",
                      color: props.textColor || "var(--primary-text-color)",
                      fontSize: props.fontSize || "15px",
                      fontWeight: props.fontWeight || "600",
                      width: props.width || "100%",
                    }}
                    onClick={() => {
                      setAddTicketOpen(true);
                    }}
                  >
                    <Feed />
                    <span>Create Ticket</span>
                  </button>
                </div>
              )}
            {!moreInfoOpen &&
              !checkListOpen &&
              !addTicketOpen &&
              !propertyInfoOpen &&
              !viewReservation &&
              !selectingReservation && (
                <div
                  className="add-ticket-button"
                  style={{
                    display: JSON.parse(localStorage.getItem("user"))
                      .permissions.canCreateTicket
                      ? "flex"
                      : "none",
                  }}
                >
                  <button
                    className="add-ticket-button__button"
                    style={{
                      backgroundColor: props.color || "var(--primary-color)",
                      color: props.textColor || "var(--primary-text-color)",
                      fontSize: props.fontSize || "15px",
                      fontWeight: props.fontWeight || "600",
                      width: props.width || "100%",
                    }}
                    onClick={() => {
                      setMoreInfoOpen(true);
                    }}
                  >
                    <Info />
                    <span>More Info</span>
                  </button>
                </div>
              )}
            {!moreInfoOpen &&
              !checkListOpen &&
              !addTicketOpen &&
              !propertyInfoOpen &&
              !viewReservation &&
              !selectingReservation && (
                <div
                  className="add-ticket-button"
                  style={{
                    display: JSON.parse(localStorage.getItem("user"))
                      .permissions.canCreateTicket
                      ? "flex"
                      : "none",
                  }}
                >
                  <button
                    className="add-ticket-button__button"
                    style={{
                      backgroundColor: props.color || "var(--primary-color)",
                      color: props.textColor || "var(--primary-text-color)",
                      fontSize: props.fontSize || "15px",
                      fontWeight: props.fontWeight || "600",
                      width: props.width || "100%",
                    }}
                    onClick={() => {
                      setPropertyInfoOpen(true);
                    }}
                  >
                    <MapsHomeWork />
                    <span>Property Info</span>
                  </button>
                </div>
              )}
            {moreInfoOpen && (
              <div display="flex" flexDirection="column" gap="20px">
                <AddActionForm
                  actionId={selectedAction._id}
                  group={
                    
                    selectedAction.group && {
                    value: {
                      _id: selectedAction.group._id,
                      name: selectedAction.group.name,
                    },
                    label: selectedAction.group.name,
                  }}
                  action_option={{
                    value: {
                      _id: selectedAction.action_option._id,
                      name: selectedAction.action_option.name,
                    },
                    label: selectedAction.action_option.name,
                  }}
                  property={{
                    value: {
                      _id: selectedAction.property._id,
                      name: selectedAction.property.name,
                    },
                    label: selectedAction.property.name,
                  }}
                  assigned_to={selectedAction.assigned_to.map((user) => {
                    return {
                      label: user.username,
                      value: {
                        _id: user._id,
                        username: user.username,
                      },
                    };
                  })}
                  date={new Date(selectedAction.planned_start_date)}
                  setPopUpWindowIsOpen={setPopUpWindowIsOpen}
                  edit={false}
                  view={true}
                  price={selectedAction.price}
                  notes={selectedAction.notes}
                />
              </div>
            )}
            {propertyInfoOpen && (
              <div style={{ width: "100%" }}>
                <ViewProperty propertyId={selectedAction.property._id} />
              </div>
            )}
            {addTicketOpen && (
              <div style={{ width: "100%" }}>
                <AddTicketForm
                  setShowAddTicketForm={setAddTicketOpen}
                  property={{
                    value: {
                      _id: selectedAction.property._id,
                      name: selectedAction.property.name,
                    },
                    label: selectedAction.property.name,
                  }}
                />
              </div>
            )}
            {(moreInfoOpen ||
              checkListOpen ||
              addTicketOpen ||
              propertyInfoOpen ||
              viewReservation ||
              selectingReservation) && (
              <div
                className="add-ticket-button"
                style={{
                  display: JSON.parse(localStorage.getItem("user")).permissions
                    .canCreateTicket
                    ? "flex"
                    : "none",
                }}
              >
                <button
                  className="add-ticket-button__button"
                  style={{
                    backgroundColor: props.color || "var(--primary-color)",
                    color: props.textColor || "var(--primary-text-color)",
                    fontSize: props.fontSize || "15px",
                    fontWeight: props.fontWeight || "600",
                    width: props.width || "100%",
                  }}
                  onClick={() => {
                    resetAllViews();
                  }}
                >
                  <span>Return</span>
                </button>
              </div>
            )}
          </div>
        </PopUpWindow>
      )}

      {isLoading ? (
        <CircularProgress />
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            maxheight: 540,
            overflow: "auto",
            overflowX: "scroll",
            width: "100%",
            paddingRight: "20px",
          }}
        >
          <Table
            aria-label="simple table"
            stickyHeader
            sx={{
              padding: "10px",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Property</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Time</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {actions.map((action) => (
                <TableRow key={action._id}>
                  <TableCell sx={{ padding: "0px" }}>
                    <Tooltip title="Προβολή" placement="right">
                      <Button
                        onClick={() => {
                          setSelectedAction(action);
                          setPopUpWindowIsOpen(true);
                        }}
                      >
                        <RemoveRedEye sx={{ color: "var(--primary-color)" }} />
                      </Button>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{action.action_option.name}</TableCell>
                  <TableCell>{action.property.name}</TableCell>
                  <TableCell>
                    {new Date(action.planned_start_date).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {new Date(action.planned_start_date).toLocaleTimeString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default ViewActionsForm;
